import React from "react";

const LegalLayout = ({ title, children }) => {
  return (
    <main className="min-h-screen bg-gray-50 pt-28 pb-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#001F3F] to-[#003366] rounded-3xl p-10 text-white shadow-xl mb-8">
          <h1 className="text-3xl md:text-4xl font-bold">
            {title}
          </h1>

          <p className="mt-3 text-white/90">
             ONE SHOP E-TİCARET KOZMETİK ÜRÜNLERİ TİCARET LTD. ŞTİ. Resmi Satış Sitesi
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-3xl shadow-md border border-gray-200 p-8 md:p-10">
          <div className="prose prose-gray max-w-none">
            {children}
          </div>

          {/* Company Information */}
          <div className="border-t mt-10 pt-8">
            <h3 className="text-lg font-semibold text-[#001F3F] mb-4">
              Şirket Bilgileri
            </h3>

            <div className="grid gap-3 text-sm text-gray-700">
              <p>
                <strong>Şirket Ünvanı:</strong><br />
                One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ.
              </p>

              <p>
                <strong>Adres:</strong><br />
                Genç Osman Mahallesi<br />
                Pınar Sokak No:9<br />
                Güngören / İstanbul
              </p>

              <p>
                <strong>Telefon:</strong><br />
                <a
                  href="tel:+905372101452"
                  className="text-[#001F3F] hover:underline"
                >
                  +90 537 210 14 52
                </a>
              </p>

              <p>
                <strong>E-posta:</strong><br />
                <a
                  href="mailto:goomoreinternational@gmail.com"
                  className="text-[#001F3F] hover:underline break-all"
                >
                  goomoreinternational@gmail.com
                </a>
              </p>

              <p>
                <strong>Vergi Dairesi:</strong><br />
                Esenler Vergi Dairesi
              </p>

              <p>
                <strong>Vergi No:</strong><br />
                6430860629
              </p>
            </div>

            <div className="border-t mt-8 pt-6 text-sm text-gray-500">
              <p>
                Son Güncelleme: 23.07.2026
              </p>

              <p className="mt-2">
                © 2026 One Shop E-ticaret Kozmetik Ürünleri Ticaret LTD. ŞTİ. Tüm hakları saklıdır.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default LegalLayout;